import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import style from './AirDate.module.scss';

const AirDate = ({ airDate, bullet, formattedDuration, dark = false, theme = {} }) => {
  const darkStyle = dark ? [style.dark, theme.dark] : [];
  const classes = [style.airDate, theme.airDate, ...darkStyle];
  return (
    <div className={classNames(classes)}>
      {airDate} {bullet} {formattedDuration}
    </div>
  );
};

AirDate.propTypes = {
  airDate: PropTypes.string,
  bullet: PropTypes.string,
  dark: PropTypes.bool.isRequired,
  formattedDuration: PropTypes.string,
  theme: PropTypes.shape({}),
};

export default AirDate;
